function updateLikeButtonFromPlayer(newPlayerEl, player) {
  if (!newPlayerEl) return;

  const lessonId = newPlayerEl.getAttribute("data-lesson-id");
  const likedStatus = newPlayerEl.getAttribute("data-liked-status");

  if (!lessonId) return;

  // Update main lesson like button
  const actions = document.querySelector(".js-lesson-actions");
  if (actions) {
    const form = actions.querySelector("form");
    const button = form?.querySelector("button");
    const labelSpan = button?.querySelector("span");

    if (form) {
      form.action = `/lesson/${lessonId}/likes/toggle`;
    }

    if (button && likedStatus != null) {
      button.dataset.status = likedStatus;
    }

    if (labelSpan && likedStatus != null) {
      labelSpan.textContent = likedStatus === "true" ? "Saved" : "Save lesson";
    }
  }

  // Keep the player element dataset in sync so that other
  // components (e.g. autoplay overlay) can rely on it
  const playerEl = player.el();
  playerEl.dataset.lessonId = lessonId;
  if (likedStatus != null) {
    playerEl.dataset.likedStatus = likedStatus;
  } else {
    delete playerEl.dataset.likedStatus;
  }
}

export { updateLikeButtonFromPlayer };
